import { Action } from '@ngrx/store';

export enum ToolIdAction {
  Set = '[ToolId] Set',
  Reset = '[ToolId] Reset',
  Sync = '[ToolId] Sync',
}

export class Set implements Action {
  readonly type = ToolIdAction.Set;

  constructor(public payload: number) {}
}

export class Reset implements Action {
  readonly type = ToolIdAction.Reset;
}

export class Sync implements Action {
  readonly type = ToolIdAction.Sync;

  constructor(public payload: number[]) {}
}

export type ToolIdActionType = Set | Reset | Sync;
